import { apiTom } from '@auteco/enviroment/apiTom'
import { apiTomLogs } from '@auteco/enviroment/apiLog'

// logs

const getToken =  () =>  JSON.parse(sessionStorage.getItem('userInfo')).token || null

const postLogTom = async (body) => {
  try {
    const response = await apiTomLogs.post('send_log/', body,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `${getToken()}`,
        },
      }
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

// roles

const getRolesUsers = async () => {
  try {
    const response = await apiTom.get('v1/roles/')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getRolesList = async () => {
  try {
    const response = await apiTom.get('v1/roles/list/')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postRolToUser = async (body) => {
  try {
    const response = await apiTom.post('v1/roles/', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const putRolToUser = async (body) => {
  try {
    const response = await apiTom.put('v1/roles/', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const deleteRolToUser = async ({ usuarioId, rolId }) => {
  try {
    const response = await apiTom.delete(
      `v1/roles/?usuarioId=${usuarioId}&rolId=${rolId}`,
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getMyRol = async () => {
  try {
    const response = await apiTom.get('v1/roles/iam/')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

// estadisticas

const getDeltas = async () => {
  try {
    const response = await apiTom.get('v1/estadisticas/deltas/')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getEventos = async () => {
  try {
    const response = await apiTom.get('v1/estadisticas/eventos/')
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getEventosByRol = async (rolId) => {
  try {
    const response = await apiTom.get(
      `v1/estadisticas/eventos_rol/?rol_id=${rolId}`,
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const getDocumentEstadistica = async (rolId) => {
  try {
    const response = await apiTom.get(
      `v1/estadisticas/eventos/descarga/?rol_id=${rolId}`,
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

// bitacora

const postBitacora = async (body) => {
  try {
    const response = await apiTom.post('v1/bitacora/', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

const postMultipleBitacora = async (body) => {
  try {
    const response = await apiTom.post('v1/bitacora/multiple/', body)
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

// alertas

const getAlertas = async () => {
  try {
    const response = await apiTom.get(
      'v1/estadisticas/alertas/?timestamp=0&id=0',
    )
    if (response.status === 200) {
      return response.data
    }
    return false
  } catch (error) {
    return false
  }
}

export {
  getRolesUsers,
  getRolesList,
  postRolToUser,
  putRolToUser,
  deleteRolToUser,
  getDeltas,
  getEventos,
  getMyRol,
  getEventosByRol,
  postBitacora,
  getAlertas,
  getDocumentEstadistica,
  postMultipleBitacora,
  postLogTom,
}
